import { Routes, Route } from 'react-router-dom';
import { hasAuthParams, useAuth } from 'react-oidc-context';
import { useEffect, useRef } from 'react';

import AdminNavbar from '@App/pages/Admin/AdminNavbar/AdminNavbar';
import AdminSidebar from '@App/pages/Admin/AdminSidebar/AdminSidebar';
import AdminOverview from '@App/pages/Admin/AdminOverview/AdminOverview';
import AdminPlans from '@App/pages/Admin/AdminPlans/AdminPlans';
import AdminStories from '@App/pages/Admin/AdminStories/AdminStories';
import AdminUsers from '@App/pages/Admin/AdminUsers/AdminUsers';
import AdminEditPlan from '@App/pages/Admin/AdminEditPlan/AdminEditPlan';
import AdminEditStory from '@App/pages/Admin/AdminEditStory/AdminEditStory';
import AdminWelcomePage from '@App/pages/Admin/AdminWelcomePage/AdminWelcomePage';

import './admin.styl';

function Admin() {
  const {
    activeNavigator,
    isAuthenticated,
    isLoading,
    signinSilent,
    user,
  } = useAuth();
  const triedSignIn = useRef(false);

  useEffect(() => {
    if (!hasAuthParams() && !activeNavigator && !isLoading && !isAuthenticated && !triedSignIn.current) {
      triedSignIn.current = true;
      signinSilent();
    }
  }, [isLoading, isAuthenticated, activeNavigator]);

  const isApproved = user && user.profile?.['custom:isApproved'] === 'true';

  if (isLoading || !isApproved) {
    return <AdminWelcomePage isApproved={isApproved} />
  }

  return (
    <div className="admin">
      <AdminNavbar />
      <div className="admin__content">
        <AdminSidebar />
        <div className="admin__content__main">
          <Routes>
            <Route path="/" element={<AdminOverview />} />
            <Route path="/plans" element={<AdminPlans />} />
            <Route path="/plans/:id" element={<AdminEditPlan />} />
            <Route path="/stories" element={<AdminStories />} />
            <Route path="/stories/:id" element={<AdminEditStory />} />
            <Route path="/users" element={<AdminUsers />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Admin;